import type { StaticDataRouteOption } from '@tanstack/react-router';
import type { PermissionChecker } from '../lib/permission-set';
import type { PermissionKey } from './catalog';

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    /**
     * The UI permission a route requires. Declared once on the route
     * (`staticData: { permission: 'orders.view' }`); the root guard enforces
     * it and the sidebar hides links to it. A nested route needs its own key
     * AND every ancestor's.
     */
    permission?: PermissionKey;
  }
}

/**
 * Whether every route in a matched branch is permitted. Takes the branch's
 * `staticData` (router matches in `beforeLoad`, or `route.options.staticData`
 * from `router.getMatchedRoutes`). Routes without a `permission` are open.
 */
export function canAccessRoutes(
  branch: Iterable<StaticDataRouteOption | undefined>,
  can: PermissionChecker,
): boolean {
  for (const staticData of branch) {
    const permission = staticData?.permission;
    if (permission !== undefined && !can(permission)) return false;
  }
  return true;
}
